export default __webpack_public_path__ + "static/media/grd-logo2.8d283c55.png";